import {RootDesc} from "@/components/ui/descriptions/RootDesc";
import {SmallDesc} from "@/components/ui/descriptions/SmallDesc";
import {BorderArticle} from "@/components/ui/general/BorderArticle";

import React from "react";

import {H3} from "@ui/titles/H3";
import {SCENARIO_CERTIFICATION_BADGES} from "@variables";
import moment from "moment/min/moment-with-locales";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const Certifications = () => {
  const {t} = useTranslation();

  const {current} = useSelector((state) => state.user.view);
  const {badges: candidateBadges} = useSelector(
    (state) => state.common.candidate,
  );

  const badges = current?.badges || candidateBadges;

  return (
    <div className={styles.certifications}>
      <div className={styles.certificationsHead}>
        <H3>{t("page.profile.certifications.title")}</H3>
      </div>

      {badges &&
        (badges?.length === 0 ? (
          <RootDesc>
            <span style={{color: "var(--grey)"}}>
              {t("page.profile.certifications.no_badges")}
            </span>
          </RootDesc>
        ) : (
          <ul className={styles.badgeContent}>
            {badges.map((item, index) => (
              <li key={index}>
                <img
                  src={
                    SCENARIO_CERTIFICATION_BADGES.find(
                      (badge) => badge.name === item.badge,
                    )?.image
                  }
                  alt={item.badge}
                />

                <i>
                  <BorderArticle>
                    <SmallDesc>
                      <b>
                        {t("page.profile.certifications.date_at")}{" "}
                        {moment(item.start_date).format("DD.MM.YYYY")}
                      </b>
                    </SmallDesc>

                    <SmallDesc>
                      <span>
                        {t("page.profile.certifications.date_completed")}{" "}
                        {moment(item.finished_at).format("DD.MM.YYYY")}
                      </span>
                    </SmallDesc>
                  </BorderArticle>
                </i>
              </li>
            ))}
          </ul>
        ))}
    </div>
  );
};
